import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getDoctorList = (formData) => {
    return axiosInstance.post(`api/doctors/list`, formData);
}

export const statusDoctor = (id) => {
    return axiosInstance.post(`api/doctors/change-status?doctorId=${id}`,{});
}

export const deleteDoctor = (id) => {
    return axiosInstance.post(`api/doctors/delete?doctorId=${id}`,{});
}

export const addDoctor = (formData) => {
    return axiosInstance.post(`api/doctors/add`,formData);
}

export const updateDoctor = (id,formData) => {
    return axiosInstance.post(`api/doctors/update?doctorId=${id}`,formData);
}

export const viewDoctor = (id) => {
    return axiosInstance.post(`api/doctors/detail?doctorId=${id}`,{});
}

export const masterTest = () => {
    return axiosInstance.post(`api/test/master`,{});
}

export const peymentDoctor = (formData) => {
    return axiosInstance.post(`api/doctors/pay-commision`,formData);
}

export const testListBytDoctor = (id,formData) => {
    return axiosInstance.post(`api/doctors/list-of-commsion/${id}`,formData);
}